module.exports = require("vuetify/lib/components/VApp");